import { Empty } from 'antd';
import { saveAs } from 'file-saver';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { GetDocumentLink } from 'store/actions/complianceActions';
import { getFile, setIsLoadingDocument } from 'store/actions/editorActions';
import { extractDocName } from '../../../utils';

export default function NotSupported({ currentVersion }) {
    const dispatch = useDispatch();

    const handleDownloadPolicy = useCallback(async () => {
        try {
            dispatch(setIsLoadingDocument(true));

            const authorizedUrlResponse = await dispatch(GetDocumentLink('userdoc', currentVersion?.id));
            if (!authorizedUrlResponse?.success) {
                throw new Error('Failed to get authorized document link');
            }

            const fileResponse = await dispatch(getFile(authorizedUrlResponse?.data));
            if (!fileResponse?.success) {
                throw new Error(fileResponse?.message);
            }

            saveAs(
                fileResponse?.blob,
                extractDocName((currentVersion?.filename || currentVersion?.document)?.replaceAll('_', ' '))
            );
        } catch (error) {
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            dispatch(setIsLoadingDocument(false));
        }
    }, [dispatch, currentVersion]);

    useEffect(() => {
        const downloadPolicyButton = document.getElementById('download-policy-button');

        if (!downloadPolicyButton) return;

        downloadPolicyButton.addEventListener('click', handleDownloadPolicy);

        return () => {
            downloadPolicyButton.removeEventListener('click', handleDownloadPolicy);
        };
    }, [handleDownloadPolicy]);

    return <Empty description="File format not supported for preview" />;
}
